module.exports = __webpack_public_path__ + "static/media/icon-tick-white.4890264f.svg";